<template>
    <div class="fill-height bg_auth" style="width: 100%">
        <v-container class="login">
            <v-row class="d-flex align-center justify-center fill-height" style="height: 100%">
                <v-col cols="10" md="6">
                    <div>
                        <div class="d-flex justify-center mb-4">
                            <img
                                src="/img/bobbee_logo_3.png"
                                :height="!$vuetify.display.mobile ? '100vh' : ''"
                                :width="!$vuetify.display.mobile ? '' : '200vw'"
                            />
                        </div>
                        <v-col cols="12" class="mb-4">
                            <v-text-field
                                label="Votre adresse mail"
                                hide-details="auto"
                                readonly
                                :model-value="decryptedEmail"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                label="Votre mot de passe"
                                :type="displayPassword ? 'text' : 'password'"
                                v-model="password"
                                @keyup.enter="firstConnexion"
                                :append-inner-icon="displayPassword ? '$oss-eye' : '$oss-eye-slash'"
                                :rules="passwordRules"
                                data-cy="password"
                                density="compact"
                                @click:append-inner="displayPassword = !displayPassword"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                label="Confirmez votre mot de passe"
                                :type="displayPassword ? 'text' : 'password'"
                                v-model="confirmPassword"
                                @keyup.enter="firstConnexion"
                                :append-inner-icon="displayPassword ? '$oss-eye' : '$oss-eye-slash'"
                                :error="error.length > 0"
                                :error-messages="error"
                                :rules="confirmPasswordRules"
                                data-cy="password"
                                density="compact"
                                @click:append-inner="displayPassword = !displayPassword"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-alert
                                type="info"
                                variant="outlined"
                                density="compact"
                                color="primary"
                            >
                                Votre mot de passe doit contenir au moins 6 caractères avec au moins
                                une majuscule et un chiffre
                            </v-alert>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-btn-primary
                                class="rounded-lg"
                                block
                                :loading="loading"
                                @click="firstConnexion"
                                data-cy="login"
                                :disabled="
                                    password.length === 0 ||
                                    confirmPassword.length === 0 ||
                                    password !== confirmPassword
                                "
                                size="large"
                            >
                                Valider
                            </v-btn-primary>
                        </v-col>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script lang="ts">
import { AuthServices } from "@/services/auth.services";
import crypto from "crypto-js";
import { Prop, Component, Vue, toNative } from "vue-facing-decorator";
import { useDisplay } from "vuetify";
import { computed, Ref } from "vue";

@Component
export class FirstConnexion extends Vue {
    // @Prop() readonly temporaryPassword!: string
    @Prop() readonly email!: string;
    password: string = "";
    confirmPassword: string = "";

    displayPassword: boolean = false;
    isMobile: Ref<boolean>;
    error: string = "";

    loading = false;

    created() {
        const { mobile } = useDisplay();
        this.isMobile = computed(() => mobile.value);
    }

    get temporaryPassword(): string {
        const path = this.$route.fullPath.split("?key=");
        if (path.length > 1) {
            return decodeURI(path.at(-1));
        }
        console.log("temporaryPassword not found");
        return "";
    }

    get passwordRules() {
        return [
            (v: string) => !!v || "Le mot de passe est requis",
            (v: string) => v.length >= 6 || "Le mot de passe doit contenir au moins 6 caractères",
            (v: string) => {
                const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/;
                return (
                    pattern.test(v) ||
                    "Le mot de passe doit contenir au moins 6 caractères avec au moins une majuscule et un chiffre"
                );
            },
        ];
    }

    get confirmPasswordRules() {
        return [
            (v: string) => !!v || "Le mot de passe est requis",
            (v: string) => v === this.password || "Les mots de passe ne correspondent pas",
        ];
    }

    get decryptedEmail() {
        return this.decryptText(this.email).toLowerCase();
    }

    async firstConnexion() {
        this.loading = true;
        if (this.password !== this.confirmPassword) {
            this.error = "Les mots de passe ne correspondent pas";
            this.loading = false;
            return;
        }
        if (!/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/.test(this.password)) {
            this.error =
                "Le mot de passe doit contenir 6 caractères avec au moins une lettre et un chiffre";
            this.loading = false;
            return;
        }
        try {
            await AuthServices.firstConnexionPasswordDefinition({
                userEmail: this.decryptedEmail,
                temporaryPassword: this.temporaryPassword,
                newPassword: this.password,
            });
        } catch (error) {
            debugger;
            console.log(error);
            this.error = "Une erreur est survenue, veuillez contacter le support";
            this.loading = false;
            return;
        }
        this.$router.push({ name: "redirectSSO" });
        this.loading = false;
    }

    decryptText(secretText) {
        const bytes = crypto.AES.decrypt(secretText, "bobbee");
        const originalText = bytes.toString(crypto.enc.Utf8);
        return originalText;
    }
}

export default toNative(FirstConnexion);
</script>

<style scoped>
.bg_auth {
    height: "100%";
    display: flex;
    flex-direction: column;
    justify-content: right;
    background-image: url("../../assets/img/bg_auth.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
}
</style>
